"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _Raven = _interopRequireDefault(require("Raven"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _getTimezoneGroups = _interopRequireDefault(require("timezone-utils/utils/getTimezoneGroups"));

var _getTimezoneOptions3 = _interopRequireDefault(require("MeetingsLib/utils/getTimezoneOptions"));

var _timezone = require("MeetingsLib/constants/timezone");

var TimezoneSelect = (0, _createReactClass.default)({
  displayName: "TimezoneSelect",
  propTypes: {
    userTimezone: _propTypes.default.string.isRequired,
    setTimezone: _propTypes.default.func.isRequired,
    activeLocale: _propTypes.default.string
  },
  getInitialState: function getInitialState() {
    return {
      options: null,
      optionsMap: null,
      parsedUserTimezone: null
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    var userTimezone = this.props.userTimezone;
    setTimeout(function () {
      var _getTimezoneOptions = (0, _getTimezoneOptions3.default)(),
          options = _getTimezoneOptions.options,
          optionsMap = _getTimezoneOptions.optionsMap;

      var parsedUserTimezone = _timezone.INVALID_TZ_GUESS;

      try {
        parsedUserTimezone = (0, _getTimezoneGroups.default)().resolve(userTimezone);
      } catch (error) {
        _Raven.default.captureMessage("Invalid timezone was given by `moment.tz.guess()`", {
          extra: {
            userTimezone: userTimezone,
            error: error
          }
        });
      }

      _this.setState({
        options: options,
        optionsMap: optionsMap,
        parsedUserTimezone: parsedUserTimezone
      });
    }, 0);
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props = this.props,
        currentActiveLocale = _this$props.activeLocale,
        currentUserTimezone = _this$props.userTimezone;
    var nextActiveLocale = nextProps.activeLocale,
        nextUserTimezone = nextProps.userTimezone;

    if (currentActiveLocale !== nextActiveLocale) {
      var _getTimezoneOptions2 = (0, _getTimezoneOptions3.default)(),
          options = _getTimezoneOptions2.options,
          optionsMap = _getTimezoneOptions2.optionsMap;

      this.setState({
        options: options,
        optionsMap: optionsMap
      });
    }

    if (currentUserTimezone !== nextUserTimezone) {
      this.setState({
        parsedUserTimezone: (0, _getTimezoneGroups.default)().resolve(nextUserTimezone)
      });
    }
  },
  onTimezoneChange: function onTimezoneChange(_ref) {
    var value = _ref.target.value;
    var setTimezone = this.props.setTimezone;
    setTimezone(value);
  },
  renderDropdownText: function renderDropdownText() {
    var _this$state = this.state,
        optionsMap = _this$state.optionsMap,
        parsedUserTimezone = _this$state.parsedUserTimezone;
    return optionsMap[parsedUserTimezone].value || parsedUserTimezone;
  },
  renderAriaLabel: function renderAriaLabel(optionsMap, parsedUserTimezone) {
    var userTimezone = optionsMap[parsedUserTimezone];

    if (userTimezone) {
      return _I18n.default.text('prebook.timePicker.timezoneLabel', {
        userTimezone: userTimezone
      });
    }

    return _I18n.default.text('prebook.timePicker.timezoneLabelNoneDisplayed');
  },
  render: function render() {
    var _this$state2 = this.state,
        options = _this$state2.options,
        optionsMap = _this$state2.optionsMap,
        parsedUserTimezone = _this$state2.parsedUserTimezone;

    if (options === null) {
      return _react.default.createElement(_UILoadingSpinner.default, {
        layout: "centered"
      });
    }

    return _react.default.createElement("div", {
      id: "timezone-select-label",
      "aria-label": this.renderAriaLabel(optionsMap, parsedUserTimezone)
    }, _react.default.createElement(_UISelect.default, {
      "aria-labelledby": 'timezone-select-label',
      "data-selenium-test": "timezone-select",
      searchClassName: "timezone-select-search",
      className: "p-left-0 p-top-1",
      menuWidth: 275,
      buttonUse: "transparent",
      defaultValue: this.renderDropdownText(),
      placement: "bottom",
      onChange: this.onTimezoneChange,
      options: this.state.options
    }));
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    activeLocale: state.activeLocale
  };
})(TimezoneSelect);

exports.default = _default;
module.exports = exports.default;